export default __webpack_public_path__ + "static/media/Dtracker.89360b34.jpg";